import React from 'react';
import { Link } from 'react-router-dom';

function Navbar({ username, onLogout, toggleOverlay }) {
  return (
    <div className="navbar">
        <div className="navbar-left">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/differ" className="nav-link">Diff Tool</Link>
            <Link to="/transTool" className="nav-link">Translation Helper</Link>
            <Link to="/localSearch" className="nav-link">Local Search</Link>
            <Link to="/workbench" className="nav-link">Workbench</Link>
            <Link to="/batchTranslate" className="nav-link">Batch Translator</Link>
            <Link to="/dataDiff" className="nav-link">Data Diff</Link>
            <Link to="/terms" className="nav-link">Terms</Link>
            {(username === 'lyrei' || username === 'admin') && toggleOverlay && (
              <button type="button" onClick={() => toggleOverlay(true)} className="nav-link nav-button">Update Database</button>
            )}
        </div>
        <div className="navbar-right">
            <span className="username">{username}</span>
            <button onClick={onLogout}>Logout</button>
        </div>
    </div>
  );
}

export default Navbar;
